// API Endpoint configuration
const getApiBaseUrl = () => {
  // If running locally on Vite (port 3000), point to local Wrangler Worker (port 8787)
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:8787';
  }
  // In production, assume Pages + Workers share the same origin or are routed via subpath
  return window.location.origin;
};

const API_BASE = getApiBaseUrl();

document.addEventListener('DOMContentLoaded', () => {
  initCustomImages();
  initMobileMenu();
  initQuoteForm();
  initPortfolioSection();
  initReviewsSection();
});

function initCustomImages() {
  const imgs = document.querySelectorAll('img[data-img-key]');
  
  // Hide images initially to prevent the stock-photo flashing effect
  imgs.forEach(img => {
    img.style.opacity = '0';
    img.style.transition = 'opacity 0.25s ease-in-out';
  });

  fetch(`${API_BASE}/api/images`)
    .then(res => {
      if (res.ok) return res.json();
      throw new Error('Failed to load images config');
    })
    .then(config => {
      if (!config) {
        imgs.forEach(img => img.style.opacity = '1');
        return;
      }

      // Update text settings from D1 database configuration
      document.querySelectorAll('[data-text-key]').forEach(el => {
        const key = el.getAttribute('data-text-key');
        if (config[key]) {
          el.textContent = config[key];
        }
      });
      
      // Update phone href links if customized
      if (config['phone_number']) {
        const cleanPhone = config['phone_number'].replace(/[^0-9]/g, '');
        document.querySelectorAll('a[href^="tel:"]').forEach(el => {
          el.href = `tel:${cleanPhone}`;
        });
      }
      
      let customApplied = 0;
      imgs.forEach(img => {
        const key = img.getAttribute('data-img-key');
        if (config[key]) {
          customApplied++;
          // Trigger fade-in only when the new image is completely downloaded by the browser
          img.onload = () => {
            img.style.opacity = '1';
          };
          img.onerror = () => {
            img.style.opacity = '1';
          };
          img.src = config[key];
        } else {
          // No override exists, reveal default immediately
          img.style.opacity = '1';
        }
      });

      if (customApplied === 0) {
        imgs.forEach(img => img.style.opacity = '1');
      }
    })
    .catch(err => {
      console.warn('Using default fallback illustration photos.', err);
      // Fallback: make sure all images are visible if API request fails
      imgs.forEach(img => img.style.opacity = '1');
    });
}


/* -------------------------------------------------------------
 * 1. MOBILE NAVIGATION MENU
 * ------------------------------------------------------------- */
function initMobileMenu() {
  const toggleBtn = document.querySelector('.mobile-menu-toggle');
  const mainNav = document.getElementById('main-nav');
  const navLinks = document.querySelectorAll('.main-nav a');

  if (!toggleBtn || !mainNav) return;

  const toggleMenu = () => {
    const isExpanded = toggleBtn.getAttribute('aria-expanded') === 'true';
    toggleBtn.setAttribute('aria-expanded', !isExpanded);
    toggleBtn.classList.toggle('active');
    mainNav.classList.toggle('active');
    document.body.style.overflow = isExpanded ? '' : 'hidden'; // Prevent scroll when open
  };

  toggleBtn.addEventListener('click', toggleMenu);

  // Close menu when a link is clicked
  navLinks.forEach(link => {
    link.addEventListener('click', () => {
      toggleBtn.setAttribute('aria-expanded', 'false');
      toggleBtn.classList.remove('active');
      mainNav.classList.remove('remove');
      mainNav.classList.remove('active');
      document.body.style.overflow = '';
    });
  });
}

/* -------------------------------------------------------------
 * 2. ESTIMATE PRICE & LINE REDIRECT FORM
 * ------------------------------------------------------------- */
function initQuoteForm() {
  const quoteForm = document.getElementById('quote-form');
  const btnSubmit = document.getElementById('btn-submit-quote');
  const formMessage = document.getElementById('quote-form-message');

  if (!quoteForm) return;

  quoteForm.addEventListener('submit', async (e) => {
    e.preventDefault();

    // Change button state to loading
    const originalText = btnSubmit.innerHTML;
    btnSubmit.disabled = true;
    btnSubmit.innerHTML = '⏳ กำลังส่งข้อมูลประเมินราคา...';
    
    if (formMessage) {
      formMessage.style.display = 'none';
      formMessage.className = 'form-message';
    }

    // Retrieve form fields
    const firstName = document.getElementById('first-name').value.trim();
    const lastName = document.getElementById('last-name').value.trim();
    const phone = document.getElementById('phone').value.trim();
    const email = document.getElementById('email').value.trim();
    const serviceType = document.getElementById('service-type').value;
    const details = document.getElementById('details').value.trim();

    // Data payload
    const payload = {
      firstName,
      lastName,
      phone,
      email,
      serviceType,
      details,
      timestamp: new Date().toISOString()
    };

    try {
      const res = await fetch(`${API_BASE}/api/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (res.ok) {
        if (formMessage) {
          formMessage.textContent = '✅ ส่งข้อมูลสำเร็จแล้ว! เจ้าหน้าที่ได้รับข้อมูลและจะติดต่อกลับหาคุณโดยเร็วที่สุด';
          formMessage.classList.add('success');
          formMessage.style.display = 'block';
        }
        quoteForm.reset();
      } else {
        throw new Error('Failed to submit quote request');
      }
    } catch (err) {
      console.warn('Backend submission failed:', err);
      if (formMessage) {
        formMessage.textContent = '❌ ขออภัย ระบบขัดข้องชั่วคราว กรุณาโทรศัพท์ติดต่อหรือแอดไลน์หาเราโดยตรง';
        formMessage.classList.add('error');
        formMessage.style.display = 'block';
      }
    } finally {
      // Reset button state
      btnSubmit.disabled = false;
      btnSubmit.innerHTML = originalText;
    }
  });
}

/* -------------------------------------------------------------
 * 3. REVIEWS SYSTEM (Fetch & Submission)
 * ------------------------------------------------------------- */
function initReviewsSection() {
  const reviewsContainer = document.getElementById('reviews-list-container');
  const reviewForm = document.getElementById('review-form');
  const formMessage = document.getElementById('review-form-message');
  const btnSubmitReview = document.getElementById('btn-submit-review');

  // Hardcoded default reviews in case API is offline or empty (avoids blank states)
  const defaultReviews = [
    {
      name: 'คุณสมชาย เลิศรัตน์',
      service: 'ย้ายครัว & ย้ายบ้าน',
      rating: 5,
      comment: 'ย้ายครัวและจานชามแตกง่ายมาที่บ้านใหม่ ไม่มีใบไหนเสียหายเลยครับ พี่คนขับดูแลและจัดของดีมาก สุภาพเป็นกันเอง แนะนำเลยครับ',
      date: '2 วันที่แล้ว'
    },
    {
      name: 'คุณวิภาวรรณ ใจดี',
      service: 'รับส่งสัตว์เลี้ยง',
      rating: 5,
      comment: 'ส่งน้องหมาไปต่างจังหวัดเป็นกังวลมาก แต่พี่คนขับส่งอัปเดตรูปถ่ายน้องตลอดการเดินทาง น้องปลอดภัยดีและไม่เครียดเลยค่ะ บริการดีเยี่ยมที่สุด',
      date: '1 สัปดาห์ก่อน'
    },
    {
      name: 'คุณอนันต์ แสนสุข',
      service: 'ขนส่งมอเตอร์ไซค์',
      rating: 5,
      comment: 'ส่ง Big Bike จากกรุงเทพฯ ไปเชียงใหม่ รถไม่มีริ้วรอยเลยครับ มัดแน่นและป้องกันแฮนด์กับตัวถังรถเป็นอย่างดี รวดเร็วและไว้ใจได้จริงครับ',
      date: '2 สัปดาห์ก่อน'
    }
  ];

  // Helper to render reviews
  const renderReviews = (reviewsList) => {
    if (!reviewsContainer) return;
    
    // Combine defaults and API loaded reviews (API first, then defaults if empty)
    const listToRender = reviewsList && reviewsList.length > 0 ? reviewsList : defaultReviews;
    
    reviewsContainer.innerHTML = '';
    
    listToRender.forEach(rev => {
      const stars = '⭐'.repeat(rev.rating) + '☆'.repeat(5 - rev.rating);
      
      const card = document.createElement('div');
      card.className = 'review-card shadow-effect';
      card.innerHTML = `
        <div class="review-header">
          <div class="customer-info">
            <span class="customer-avatar">👤</span>
            <div>
              <h4 class="customer-name">${escapeHTML(rev.name)}</h4>
              <span class="service-badge">${escapeHTML(rev.service)}</span>
            </div>
          </div>
          <div class="star-rating">${stars}</div>
        </div>
        <p class="review-comment">${escapeHTML(rev.comment)}</p>
        <span class="review-date">${rev.date || 'ไม่นานมานี้'}</span>
      `;
      reviewsContainer.appendChild(card);
    });
  };

  // Fetch reviews from API
  const fetchReviews = async () => {
    try {
      const res = await fetch(`${API_BASE}/api/reviews`);
      if (res.ok) {
        const data = await res.json();
        renderReviews(data);
      } else {
        renderReviews(defaultReviews);
      }
    } catch (err) {
      console.warn('Could not fetch reviews from Workers API, loading local defaults.', err);
      renderReviews(defaultReviews);
    }
  };

  // Submit Review Form
  if (reviewForm) {
    reviewForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      btnSubmitReview.disabled = true;
      btnSubmitReview.textContent = 'กำลังส่งรีวิว...';
      formMessage.style.display = 'none';
      formMessage.className = 'form-message';

      const name = document.getElementById('review-name').value.trim();
      const service = document.getElementById('review-service').value;
      const ratingVal = reviewForm.querySelector('input[name="rating"]:checked')?.value || '5';
      const comment = document.getElementById('review-text').value.trim();

      const newReview = {
        name,
        service,
        rating: parseInt(ratingVal, 10),
        comment,
        date: 'เมื่อครู่นี้'
      };

      try {
        const res = await fetch(`${API_BASE}/api/reviews`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(newReview)
        });

        if (res.ok) {
          formMessage.textContent = 'บันทึกรีวิวของคุณสำเร็จแล้ว ขอบคุณที่ร่วมแบ่งปันประสบการณ์!';
          formMessage.classList.add('success');
          reviewForm.reset();
          
          // Re-fetch to load new review from backend
          await fetchReviews();
        } else {
          throw new Error('Server responded with error');
        }
      } catch (err) {
        console.error('Submit review error:', err);
        formMessage.textContent = 'ระบบขัดข้องชั่วคราว ไม่สามารถส่งรีวิวได้ในขณะนี้ แต่ระบบได้บันทึกไว้ในเบราว์เซอร์ของคุณแล้ว';
        formMessage.classList.add('error');
        
        // Dynamic fallback: add directly to UI list locally for visual feedback
        const localReviews = [newReview, ...defaultReviews];
        renderReviews(localReviews);
      } finally {
        btnSubmitReview.disabled = false;
        btnSubmitReview.textContent = 'ส่งรีวิวของคุณ';
        formMessage.style.display = 'block';
      }
    });
  }

  // Initial Load
  fetchReviews();
}

// Simple HTML escaping helper to prevent XSS injection
function escapeHTML(str) {
  if (!str) return '';
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

/* -------------------------------------------------------------
 * 4. PORTFOLIO GALLERY SYSTEM
 * ------------------------------------------------------------- */
function initPortfolioSection() {
  const container = document.getElementById('portfolio-grid-container');
  if (!container) return;

  const defaultPortfolio = [
    {
      image_url: 'https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?auto=format&fit=crop&w=600&q=80',
      title: 'ขนส่งรถย้ายบ้านและอุปกรณ์สำนักงาน'
    },
    {
      image_url: 'https://images.unsplash.com/photo-1558981806-ec527fa84c39?auto=format&fit=crop&w=600&q=80',
      title: 'บริการส่งรถบิ๊กไบค์อย่างปลอดภัย'
    },
    {
      image_url: 'https://images.unsplash.com/photo-1548199973-03cce0bbc87b?auto=format&fit=crop&w=600&q=80',
      title: 'ขนส่งสุนัขและสัตว์เลี้ยงข้ามจังหวัด'
    }
  ];

  const renderPortfolio = (items) => {
    container.innerHTML = '';
    const list = items && items.length > 0 ? items : defaultPortfolio;

    list.forEach(item => {
      const card = document.createElement('div');
      card.className = 'portfolio-card';
      
      const imageUrl = item.image_url.startsWith('/api/') ? `${API_BASE}${item.image_url}` : item.image_url;

      card.innerHTML = `
        <img src="${imageUrl}" alt="${escapeHTML(item.title)}" class="portfolio-img" loading="lazy">
        <div class="portfolio-overlay">
          <h3 class="portfolio-title">${escapeHTML(item.title) || 'ผลงานของเรา'}</h3>
        </div>
      `;
      container.appendChild(card);
    });
  };

  fetch(`${API_BASE}/api/portfolio`)
    .then(res => {
      if (res.ok) return res.json();
      throw new Error('Failed to load portfolio');
    })
    .then(data => {
      renderPortfolio(data);
    })
    .catch(err => {
      console.warn('Could not load portfolio from API, loading defaults.', err);
      renderPortfolio(defaultPortfolio);
    });
}
